export let noteFeedFlexPaneTitle = "p06aRb";
export default {noteFeedFlexPaneTitle};